import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import CollectionSelectModal from './Collections/SelectModalV2';

const CollectionSelectModalWrapper = ({
  modalOpen,
  enableAddNew,
  onlyOpenCollections,
  selectedCollectionUuid,
  handleClose,
  handleCollectionSelect,
  smartCollectionsRestrict,
  showSmartSection,
}) => {
  if (!modalOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={modalOpen}
      toggle={handleClose}
    >
      <CollectionSelectModal
        className="modal-collection-select"
        backdrop={true}
        enableAddNew={enableAddNew}
        onlyOpenCollections={onlyOpenCollections}
        selectedCollectionUuid={selectedCollectionUuid}
        handleClose={handleClose}
        handleCollectionSelect={handleCollectionSelect}
        smartCollectionsRestrict={smartCollectionsRestrict}
        showSmartSection={showSmartSection}
      />
    </Modal>
  );
};

CollectionSelectModalWrapper.propTypes = {
  modalOpen: PropTypes.bool,
  enableAddNew: PropTypes.bool,
  onlyOpenCollections: PropTypes.bool,
  selectedCollectionUuid: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleCollectionSelect: PropTypes.func.isRequired,
  smartCollectionsRestrict: PropTypes.bool,
  showSmartSection: PropTypes.bool,
};

CollectionSelectModalWrapper.defaultProps = {
  modalOpen: false,
  enableAddNew: false,
  onlyOpenCollections: false,
  selectedCollectionUuid: null,
  smartCollectionsRestrict: null,
  showSmartSection: true,
};

export default CollectionSelectModalWrapper;
